import { useState, useEffect, useCallback } from "react";
import {
  Card,
  CardContent,
  Typography,
  Box,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Snackbar,
  Alert,
} from "@mui/material";
import TeamPosition from "./TeamPosition";
import { League, Tournament } from "../WeekAtAGlance/IndividualTournament";
import { useNavigate } from "react-router-dom";
import { playerAPIInterface, TeamPositionPlayers } from "./TeamSubmission";
import { usePlayerAvailabilityList } from "./usePlayerAvailabilityList";
import HorseRequestWidget from "../HorseManagement/HorseRequestWidget";


function TournamentPlayerSubmission({
  devPort,
  clubId,
  eventDetails,
  managerMode,
}: {
  devPort: string;
  clubId: number;
  eventDetails: Tournament;
  managerMode: number;
}) {
  const [selectedLeague, setSelectedLeague] = useState<number | null>(null);
  const [showSuccess, setShowSuccess] = useState(false);
  const navigate = useNavigate();
  const [teamMembers, setTeamMembers] = useState<TeamPositionPlayers[]>([]);

  const { availablePlayers, unavailablePlayers, loadingPlayers } = usePlayerAvailabilityList({
    devPort,
    clubId,
    selectedLeague,
  });

  const createDefaultTeamMembers = useCallback(() => {
    const newTeamMembers: TeamPositionPlayers[] = [{
        players: [
          {
            playerId: (managerMode === -1) ? null : managerMode,
            isVisitingPlayer: false,
            visitingPlayerName: "",
            visitingPlayerRating: 0,
          },
        ],
        isSplitSpot: false,
        isTeamCaptain: false,
      }];
    setTeamMembers(newTeamMembers);
  }, [managerMode]);

  useEffect(() => {
    createDefaultTeamMembers();
  }, [selectedLeague, createDefaultTeamMembers]);

  function resetForm() {
    setSelectedLeague(null);
    createDefaultTeamMembers();
  }

  function submitTeam() {
    let errorMsg = "";
    teamMembers.forEach((member, positionIndex) => {
      member.players.forEach((player, playerIndex) => {
        if (!player.playerId && !player.visitingPlayerName) {
          errorMsg +=
            "Missing a name for position " +
            (positionIndex + 1) +
            " and player " +
            (playerIndex + 1) +
            "\n";
        }
      });
    });
    if (!selectedLeague) {
      errorMsg += "Missing a league\n";
    }
    if (errorMsg) {
      alert(errorMsg);
    } else {
      console.log(teamMembers);
      const submitTeam = devPort + "add_tournament_single_player";
      let playerInfo: playerAPIInterface | null = null;
      teamMembers.map((member, index) =>
        member.players.map((player, playerIndex) =>
          playerInfo = {
            player_id: player.playerId,
            position: index,
            is_split_spot: member.isSplitSpot,
            is_visiting_player: player.isVisitingPlayer,
            visiting_player_name: player.visitingPlayerName,
            visiting_player_handicap: player.visitingPlayerRating,
          }
        )
      );
      const signupData = {
        tournament_id: selectedLeague,
        tournament_group_id: eventDetails.id,
        club_id: clubId,
        player: playerInfo,
      };
      console.log(signupData);
      fetch(submitTeam, {
        method: "POST",
        credentials: "include",
        body: JSON.stringify(signupData),
      }).then((response) => {
        console.log(response);
        if (response.ok) {
          setShowSuccess(true);
          resetForm();
          if(managerMode!==-1){
            navigate("/tournamentsignups");
          }
        }
      });
    }
  }

  return (
    <Card sx={{ margin: "auto" }}>
      <CardContent>
        <Typography variant="h5" component="div" gutterBottom>
          Register as a Single Player
        </Typography>
        <FormControl fullWidth sx={{ mb: 2 }}>
          <InputLabel id="league-select-label">League</InputLabel>
          <Select
            labelId="league-select-label"
            id="league-select"
            value={selectedLeague}
            label="League"
            onChange={(e) => setSelectedLeague(Number(e.target.value))}
          >
            {eventDetails?.leagues?.map((league: League) => (
              <MenuItem key={league.tournament_id} value={league.tournament_id}>
                {league.league_name} ({league.handicap} handicap)
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        {!selectedLeague && (
          <Typography color="warning.main" sx={{ mb: 2 }}>
            Please select a league before registering
          </Typography>
        )}
        {selectedLeague && (
          <Box sx={{ mt: 2 }}>
            <TeamPosition
                index={0}
                positionPlayers={teamMembers[0]}
                teamMembers={teamMembers}
                setTeamMembers={setTeamMembers}
                availablePlayers={availablePlayers}
                loadingPlayers={loadingPlayers}
                unavailablePlayers={unavailablePlayers}
                isSinglePlayer={true}
                managerMode={managerMode}
              />
            {/* Horse Request Widget for tournaments */}
            {teamMembers[0]?.players[0]?.playerId && selectedLeague && (
              <Box sx={{ mt: 2 }}>
                <HorseRequestWidget
                  devPort={devPort}
                  clubId={Number(clubId)}
                  eventType="tournaments"
                  eventId={selectedLeague}
                  playerId={teamMembers[0].players[0].playerId}
                  maxChukkers={6}
                  managerMode={managerMode}
                />
              </Box>
            )}
          </Box>
        )}
        <Button
          variant="contained"
          color="primary"
          style={{ width: "100%" }}
          onClick={submitTeam}
          disabled={!selectedLeague}
        >
          Submit
        </Button>
      </CardContent>
      <Snackbar
        open={showSuccess}
        autoHideDuration={6000}
        onClose={() => setShowSuccess(false)}
      >
        <Alert onClose={() => setShowSuccess(false)} severity="success">
          Team has been successfully submitted!
        </Alert>
      </Snackbar>
    </Card>
  );
}

export default TournamentPlayerSubmission;
